import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../providers/auth_provider';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../../utils/format_date';

export default function Affiliates() {
    const { token } = useAuth();
    const [referrers, setReferrers] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchReferrer, setSearchReferrer] = useState('');
    const [searchStatus, setSearchStatus] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [sortBy, setSortBy] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        fetchReferrers(1);
        setCurrentPage(1);
    }, [limit, searchReferrer, searchStatus, sortBy, searchEmail]);

    const fetchReferrers = async (page) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/user/affiliate/referrers?page=${page}&limit=${limit}&referrer=${searchReferrer}&status=${searchStatus}&email=${searchEmail}&sort_by=${sortBy}`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            setReferrers(response.data.data);
            setPagination(response.data.pagination);
        } catch (error) {
            console.error('Error fetching Referrers:', error);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Function to handle view referrals
    const handleViewReferrals = (referral) => {
        navigate('/affiliates/view', { state: { referral } });
    };

    const handleViewUserDashboard = (user_id) => {
        navigate('/users/view', { state: { user_id } });
    };

    return (
        <>
            <Helmet>
                <title>Manage Affiliates - Enervybe</title>
            </Helmet>
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title">User Affiliates List</h5>
                    </div>
                </div>
                <div className="card-datatable text-nowrap">
                    <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div className="dataTables_length">
                                    <label>
                                        Show{' '}
                                        <select
                                            name="DataTables_Table_0_length"
                                            aria-controls="DataTables_Table_0"
                                            className="form-select form-select-sm"
                                            value={limit}
                                            onChange={(e) => setLimit(e.target.value)}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>{' '}
                                        entries
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="datatables-ajax table table-bordered dataTable no-footer"
                                aria-describedby="DataTables_Table_0_info"
                            >
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Referred By</th>
                                        <th>Affiliate Name</th>
                                        <th>Referred</th>
                                        <th>Email Id</th>
                                        <th>Phone Number</th>
                                        {/* <th>Status</th> */}
                                        <th>Total Commission</th>
                                        <th>Join On</th>
                                        <th>Action</th>

                                        {/* <th>Referred On</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="search"
                                                className="form-control form-control-sm"
                                                placeholder="Search Affiliate"
                                                value={searchReferrer}
                                                onChange={(e) => setSearchReferrer(e.target.value)}
                                            />
                                        </td>
                                        {/* <td>
                                            <select className="form-select form-select-sm" value={searchStatus} onChange={(e) => setSearchStatus(e.target.value)}>
                                                <option value="">All</option>
                                                <option value="pending">Pending</option>
                                                <option value="registered">Registered</option>
                                                <option value="subscribed">Subscribed</option>
                                            </select>
                                        </td> */}
                                        <td></td>
                                        <td>
                                            <input
                                                type="search"
                                                className="form-control form-control-sm"
                                                placeholder="Search Email"
                                                value={searchEmail}
                                                onChange={(e) => setSearchEmail(e.target.value)}
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <select className="form-select form-select-sm" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                                                <option value="">Short By Earnings</option>
                                                <option value="high_to_low">High to Low</option>
                                                <option value="low_to_high">Low to High</option>
                                            </select>
                                        </td>
                                        <td></td>
                                    </tr>
                                    {referrers?.map((referral, index) => (
                                        <tr key={referral.referrer_id}>
                                            <td>{index + 1}</td>
                                            <td>{referral?.referrer?.referral_user?.first_name} {referral?.referrer?.referral_user?.last_name}</td>
                                            <td className='text-primary cursor-pointer' onClick={() => handleViewUserDashboard(referral.referrer.id)}>{`${referral.referrer?.first_name} ${referral?.referrer?.last_name}`}</td>
                                            <td>
                                                <a className="text-primary text-decoration-underline" type="button" onClick={() => handleViewReferrals(referral)}>
                                                    {referral.referral_count} View
                                                </a>
                                            </td>
                                            <td>{referral.referrer.email}</td>
                                            <td>{referral.referrer.phone_no}</td>
                                            <td>${(Math.floor(referral?.total_earnings * 100) / 100).toFixed(2) || 0}</td>
                                            <td>{formatDate(referral?.referrer?.created_at)}</td>
                                            <td><button className='btn btn-sm text-primary border border-primary' onClick={() => handleViewUserDashboard(referral.referrer_id)}>View</button></td>                                            {/* <td>
                                                {formatDate(referral.referrer.created_at || Date.now())}
                                            </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <nav aria-label="Page navigation">
                    <ul className="pagination pagination-sm pt-2">
                        <li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage - 1)}>
                                <i className="tf-icon ri-skip-back-mini-line ri-20px" />
                            </a>
                        </li>
                        {pagination?.totalPages &&
                            Array.from({ length: pagination?.totalPages }, (_, index) => index + 1).map((page) => (
                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                    <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(page)}>
                                        {page}
                                    </a>
                                </li>
                            ))}
                        <li className={`page-item next ${currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage + 1)}>
                                <i className="tf-icon ri-skip-forward-mini-line ri-20px" />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    );
}
